module.exports = __webpack_public_path__ + "img/bg_pop_top.de72985d.png";